'use client'

import { Drawer, DrawerContent } from '@/components/ui/drawer'
import useBreakpoint from '@/hooks/use-breakpoint'
import { Box } from '@/styled-system/jsx'
import dynamic from 'next/dynamic'
import Loader from '../loader'
import { useChat } from './useChat'

const ChatContent = dynamic(() => import('./ChatContent'), {
  ssr: false,
  loading: Loader,
})

export default function Chat() {
  const { isOpen, onClose } = useChat((state) => ({
    isOpen: state.isOpen,
    onClose: state.onClose,
  }))
  const isLg = useBreakpoint('lg')

  if (!isLg) {
    return (
      <Drawer placement='right' size='md' open={isOpen} onClose={onClose}>
        <DrawerContent>
          <ChatContent />
        </DrawerContent>
      </Drawer>
    )
  }

  return isOpen ? (
    <Box
      bg='neutral.100'
      w='320px'
      h='full'
      flexShrink={0}
      borderLeftWidth='1px'
      zIndex='docked'
    >
      <ChatContent />
    </Box>
  ) : null
}
